export default function (app) {
	app.directive('attachmentHandler', function () {
		let fileExtensions = ['pdf','doc','docx','ppt','pptx','pps','ppsx','odt','xls','xlsx', 'ods', 'odp'];
		let imageExtensions = ['jpg','jpeg','png','gif'];
		return {
			restrict: 'A',
			scope: {
				uploadingObj: '='
			},
			link: function (scope, elem, attrs, ctrl) {
				scope.convertFile = function(file) {
					let convertedFile = {};
					let reader = new FileReader();
					reader.onload = function(evt) {
						let fileByteArray = [];
						if (evt.target.readyState === FileReader.DONE) {
							let arrayBuffer = evt.target.result,
								array = new Uint8Array(arrayBuffer);
							for (let i = 0; i < array.length; i++) {
								fileByteArray.push(array[i]);
							}
							convertedFile = {
								file: file,
								content: fileByteArray,
								categories: null,
								ext: (/[.]/.exec(file.name)) ? /[^.]+$/.exec(file.name)[0] : null,
								mime: file.type,
								name: file.name,
								size: file.size
							};
							scope.uploadingObj.add(convertedFile);
						}
					};
					reader.readAsArrayBuffer(file);
				};
				elem.bind('change', () => {
					scope.$apply(() => {
						let file = elem[0].files[0];
						elem[0].value = '';
						let extension = (/[.]/.exec(file.name)) ? /[^.]+$/.exec(file.name)[0] : null;
						if (extension) {
							if (fileExtensions.indexOf(extension.toLowerCase()) > -1) {
								scope.uploadingObj.start(file.name);
								scope.convertFile(file);
							} else if (imageExtensions.indexOf(extension.toLowerCase()) > -1) {
								scope.uploadingObj.start(file.name);
								let max_size = 3508; // 300 DPI esetén A4 oldal
								const reader = new FileReader();
								reader.onload = event => {
									const img = new Image();
									img.src = event.target.result;
									img.onload = () => {
										let elem = document.createElement('canvas');
										elem.width = img.width;
										elem.height = img.height;
										if (elem.width > elem.height) {
											if (elem.width > max_size) {
												elem.height *= max_size / elem.width;
												elem.width = max_size;
											}
										} else {
											if (elem.height > max_size) {
												elem.width *= max_size / elem.height;
												elem.height = max_size;
											}
										}
										const ctx = elem.getContext('2d');
										ctx.drawImage(img, 0, 0, elem.width, elem.height);
										ctx.canvas.toBlob((blob) => {
											const compressedImage = new File([blob], file.name, {
												type: file.type,
												lastModified: Date.now(),
												size: file.size
											});
											scope.convertFile(compressedImage);
										}, file.type, 1);
									};
								};
								reader.readAsDataURL(file);
							} else {
								scope.uploadingObj.fileTypeError = true;
							}
						}
					})
				});
			}
		};
	});
};
